import axios from 'axios';
import store from '../redux/store/store';

// API URL'si environment değişkenlerinden alınıyor
const API_USERFEEDBACK_URL = import.meta.env.VITE_API_URL;

const userFeedbackService = {
  addUserFeedback: async (query) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;

      const response = await axios.post(
        `${API_USERFEEDBACK_URL}/UserFeedback`,
        query,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data;
    } catch (error) {

      console.error("Ürün eklenirken bir hata oluştu:", error);
      if (error.response && error.response.data) {
        console.error("Hata yanıtı:", error.response.data);
      }
      throw error;
    }
  },
  fetchUserFeedback: async (query) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get('/UserFeedback', {
        params: {
          UserId: query.userId,
        }
        , headers: { Authorization: `Bearer ${userToken}` }
      });

      return response.data.data;
    } catch (error) {
      console.error('Error fetching invoices:', error);
      throw error;
    }
  },
}
export default userFeedbackService;
